interface LogoProps {
  className?: string;
  label?: string;
}

export const ChatGptLogo = ({
  className = 'h-8 w-8',
  label = 'ChatGPT',
}: LogoProps) => (
  <svg
    role="img"
    aria-label={label}
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{label}</title>
    <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.0462 6.0462 0 0 0 6.514 2.9001A5.9847 5.9847 0 0 0 13.26 24a6.0557 6.0557 0 0 0 6.371-5.1818 5.9847 5.9847 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0968zM13.26 22.5018a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4943zm-9.569-4.068a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.049-.5164zM2.3408 7.8956a4.485 4.4755 0 0 1 2.3655-1.9723V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071.0052l-4.7833-2.7582A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071-.0052l4.7833 2.7582a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.7833-2.7582a4.4992 4.4992 0 0 1 6.7264 4.6508zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.1419.0805L8.704 8.453a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654 2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" />
  </svg>
);

export const ClaudeLogo = ({
  className = 'h-8 w-8',
  label = 'Claude',
}: LogoProps) => (
  <svg
    role="img"
    aria-label={label}
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{label}</title>
    <path d="M13.827 3.52h3.673L24 20.48h-3.673l-6.5-16.96zm-3.654 0H6.5L0 20.48h3.674l1.466-3.64h6.395l1.466 3.64h3.675L10.173 3.52zm-2.26 10.08 2.26-5.52 2.26 5.52H7.913z" />
  </svg>
);

export const GrokLogo = ({
  className = 'h-8 w-8',
  label = 'Grok',
}: LogoProps) => (
  <svg
    role="img"
    aria-label={label}
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{label}</title>
    <path d="M6.469 8.855 2.533 5.913l1.978-.38L2.186 1.72l1.402-.655L6.4 5.125 9.21 0l1.217 1.052-2.063 4.622 4.437.854-.4 1.877-4.424-.854L8.958 15.06l-1.852.527zm10.076 14.248.4-1.877 4.424.855-1.852 4.624-1.217-1.053 2.065-4.622-4.437-.855zm5.353-2.956-1.978.38 3.937 2.942.809-1.848-3.141-2.22 2.811-4.406 1.852-.526-3.29-4.058.4-1.877 4.424.855zm-17.796.38-1.978-.38L.068 16.635l.81 1.847 3.14-2.22 2.81 4.406 1.853.526-3.29 4.058-.4 1.877-4.424-.855 2.065-4.622-4.437-.854z" />
  </svg>
);

export const GeminiLogo = ({
  className = 'h-8 w-8',
  label = 'Gemini',
}: LogoProps) => (
  <svg
    role="img"
    aria-label={label}
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{label}</title>
    <defs>
      <linearGradient
        id="geminiLogoGradient"
        x1="4"
        y1="2"
        x2="20"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4B90FF" />
        <stop offset="0.5" stopColor="#8B5CFF" />
        <stop offset="1" stopColor="#F576C6" />
      </linearGradient>
    </defs>
    <path
      fill="url(#geminiLogoGradient)"
      d="M12 0c0 6.627-5.373 12-12 12 6.627 0 12 5.373 12 12 0-6.627 5.373-12 12-12-6.627 0-12-5.373-12-12z"
    />
  </svg>
);

export const CursorLogo = ({
  className = 'h-8 w-8',
  label = 'Cursor',
}: LogoProps) => (
  <svg
    role="img"
    aria-label={label}
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{label}</title>
    <path d="M11.503.131 1.891 5.678a.84.84 0 0 0-.42.726v11.188c0 .3.162.575.42.724l9.609 5.55a1 1 0 0 0 .998 0l9.61-5.55a.84.84 0 0 0 .42-.724V6.404a.84.84 0 0 0-.42-.726L12.497.131a1.01 1.01 0 0 0-.996 0M2.657 6.338h18.55c.263 0 .43.287.297.515L12.23 22.918c-.062.107-.229.064-.229-.06V12.335a.59.59 0 0 0-.295-.51l-9.11-5.257c-.109-.063-.064-.23.061-.23" />
  </svg>
);

export const AntigravityLogo = ({
  className = 'h-8 w-8',
  label = 'Antigravity',
}: LogoProps) => (
  <svg
    role="img"
    aria-label={label}
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{label}</title>
    <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 2.2a7.8 7.8 0 0 1 6.5 12.1L12 12.9 5.5 16.3A7.8 7.8 0 0 1 12 4.2zm0 8.4 5.4 2.8A7.8 7.8 0 0 1 12 19.8 7.8 7.8 0 0 1 6.6 15.4z" />
  </svg>
);

export const OtherToolsLogo = ({
  className = 'h-8 w-8',
  label = 'Other tools',
}: LogoProps) => (
  <svg
    role="img"
    aria-label={label}
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{label}</title>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <path d="M3.27 6.96 12 12.01l8.73-5.05" />
    <path d="M12 22.08V12" />
  </svg>
);
